export default {
  ajaxUrl: null,
};



// WEBPACK FOOTER //
// ./assets/js/cf-ajax-form/defaults.js